export default __webpack_public_path__ + "static/media/acceleX.3a09b54a.svg";